import Net from '../../util/net';
import {
  GetLinkInfoReq,
  GetLinkInfoRsp,
  GetShortLinkReq,
  GetShortLinkRsp,
} from '../../typings/proto';

export default {
  /**
   * 获取链接解析信息
   * @param linkList 待解析的链接列表
   * @param needCache 是否需要从后台缓存读取(默认：是)
   */
  getLinkMsgList(linkList: string[], needCache = true): Promise<GetLinkInfoRsp> {
    return Net.request<GetLinkInfoRsp, GetLinkInfoReq>({
      data: {
        links: linkList,
        noCache: !needCache,
      },
      path: 'knockknock.LinkMsgSrv/GetLinkInfo',
    });
  },
  getShortLink(longLink: string): Promise<GetShortLinkRsp> {
    return Net.request<GetShortLinkRsp, GetShortLinkReq>({
      path: 'knockknock.ShortLinkSrv/GetShortLink',
      data: {
        longLink,
      },
    });
  },
};
